export default {
    inserted: function(el, binding) {
        if (binding.value === undefined || binding.value === true) {
            
            // Target el if it can focus, otherwise find the child button/input
            const target = typeof el.focus === 'function' ? el : el.querySelector('button, input, textarea, [tabindex]')
            
            if (!target) return
            
            let attempts = 0
            const maxAttempts = 5
            const intervalTime = 200
            
            const timer = setInterval(function() {
                attempts++
                
                if (isFocusable(target)) {
                    target.focus()
                    
                    // Verify target successfully received focus
                    if (document.activeElement === target || attempts >= maxAttempts) {
                        clearInterval(timer)
                    }
                } else if (attempts >= maxAttempts) {
                    clearInterval(timer)
                }
            }, intervalTime)
            
            // Helper to check if an element is visible and interactive in the DOM
            function isFocusable(node) {
                if (!node || node.disabled) return false
                
                // Check computed styles for hidden states
                const style = window.getComputedStyle(node)
                if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
                    return false
                }
                
                // Ensure element has physical size (isn't collapsed or off-screen)
                return !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)
            }
        }
    }
}